import { ConstraintFragment } from '@occc/graphql';
import { constraintHelper } from '@occc-app/offerHelpers/utils/constraintHelper';

export const getProductGroupIdsToLoad = (constraints: ConstraintFragment[]) => {
  let productGroupIdsToLoadSet = new Set<string>();

  if (constraints.some(constraintHelper.isPurchaseThreshold)) {
    productGroupIdsToLoadSet = constraints
      .filter(constraintHelper.isPurchaseThreshold)
      .reduce((groupsSet, constraint) => {
        for (const productGroupId of constraint.eligibleProductGroupIds) {
          groupsSet.add(productGroupId);
        }

        return groupsSet;
      }, new Set<string>());
  }

  return Array.from(productGroupIdsToLoadSet);
};
